// @ts-check
import { createPesIcon } from '../../utils/utils';
import { createElement } from '../helpers/dom-elements.js';

/**
 * @typedef {import('../../services/range-product-data-api').WEEEPrices} WEEEPrices
 */

/**
 * Generates tooltip component from weee prices data object.
 *
 * @param {WEEEPrices} param
 * @param {object} options
 * @param {boolean} [options.isAdaptive] Adds class for icon with different sizes for mobile and desktop.
 * @returns {HTMLElement}
 */
export const createWEEEPricesTooltip = (
  { weeePriceLabel, weeePriceLabelMulti, weeeLamp, weeePackage, weeePro },
  options = {}
) => {
  const { isAdaptive } = options;

  const tooltipTrigger = createElement('span', {
    className: `vertical_middle tooltip-body__trigger tooltip-body__trigger--weee-prices js-tooltip-trigger tooltip-body__icon--info${isAdaptive ? ' tooltip-body__icon--adaptive' : ''}`,
    contents: createPesIcon({
      iconName: 'information_stroke',
      size: 'SMALL',
    })
  });

  const tooltipTextLines = [weeePriceLabel, weeePriceLabelMulti, weeeLamp, weeePro, weeePackage]
    .filter(Boolean)
    .map((text) => createElement('div', {
      className: 'tooltip-body__text-line',
      contents: text
    }));

  const tooltipBody = createElement('div', {
    className: 'tooltip-body tooltip-body--top-center',
    contents: createElement('div', {
      className: 'tooltip-body__content tooltip-body__content--price js-tooltip-body-content',
      contents: createElement('div', {
        className: 'tooltip-body__description',
        contents: createElement('div', {
          className: 'tooltip-body__text',
          contents: tooltipTextLines
        })
      })
    })
  });

  return createElement('div', {
    className: 'tooltip-container tooltip-container--price js-tooltip-container',
    contents: [tooltipTrigger, tooltipBody]
  });
};

/**
 * Checks for weee prices data availability.
 *
 * @param {WEEEPrices} param
 * @returns {boolean}
 */
const hasWEEEData = ({ weeePriceLabel, weeeLamp, weeePackage, weeePro }) => Boolean(
  weeePriceLabel || weeeLamp || weeePackage || weeePro
);

/**
 * Finds tooltip placeholder and appends generated tooltip.
 *
 * @param {WEEEPrices} weeePrices
 * @param {HTMLElement} rangeProductElement
 */
export const appendWEEEPricesTooltip = (weeePrices, rangeProductElement) => {
  if (!hasWEEEData(weeePrices)) {
    return;
  }

  const placeholder = rangeProductElement.querySelector('.js-weee-prices-placeholder');

  if (placeholder) {
    const tooltip = createWEEEPricesTooltip(weeePrices, { isAdaptive: true });

    placeholder.appendChild(tooltip);
  }
};
